import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import TeaCoffeeListTabs from "@/components/menu-management/tea&coffe/tea-coffe/tea-coffe-list-tabs";
import DraftList from "@/components/menu-management/tea&coffe/tea-coffe/draft-list-tabs";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchAllTeaCoffees } from "@/redux/slice/menu-manage-slice/tea-coffee-slice";
import useAuth from "@/hooks/useAuth";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import hasPermission from "@/hooks/hasPermission";

function TeaCoffee() {
  const { user } = useAuth();
  const restaurant_id = user?.restaurant_id;
  const dispatch = useDispatch();
  const { getLoading } = useSelector((state) => state.menuManage.teaCoffee);

  useEffect(() => {
    dispatch(fetchAllTeaCoffees(restaurant_id));
    dispatch(clearItemVariants());
  }, [restaurant_id]);

  if (getLoading) return <TableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      pageName={{ title: "Tea & Coffee List" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Tea & Coffee", path: "/backoffice/menu/tea-coffee" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
          {hasPermission("back_office.menu_management.create_tea_coffee") && (
            <Link to={"/backoffice/menu/tea-coffee/create"}>
              <Button>
                <Plus /> Create Tea & Coffee
              </Button>
            </Link>
          )}
        </div>
        <Tabs
          valueKey="menu-tea-coffee"
          className="bg-transparent relative"
          defaultValue="drink"
        >
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Tea & Coffee List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <TeaCoffeeListTabs />
          <DraftList />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default TeaCoffee;
